var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 24,
    viewBox: "0 0 145 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.864 22.748V17.1242C129.566 17.9852 131.602 18.6212 133.538 18.7868C134.206 18.8465 134.842 18.8465 135.444 18.8134C137.411 18.6876 138.514 18.1774 138.514 17.217C138.514 16.0049 137.01 15.3954 134.074 14.3355C130.032 12.8715 127.429 11.2686 127.429 7.04896C127.429 2.82937 131.07 0.0737305 136.543 0.0737305C138.946 0.0737305 141.353 0.524219 142.954 1.16677V6.57206C141.519 5.70422 139.247 5.12793 137.045 5.12793C134.842 5.12793 133.438 5.86326 133.438 7.01584C133.438 8.10215 134.842 8.83749 137.646 9.9238C141.685 11.4606 144.458 13.0901 144.458 17.1839C144.458 21.4365 141.118 24.0001 135.143 24.0001C132.404 24 129.666 23.4833 127.864 22.748Z",
    fill: "#587E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5388 0.388916H31.2998V23.621H37.5388V0.388916Z",
    fill: "#587E85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.503 0.388916H117.264V23.621H123.503V0.388916Z",
    fill: "#587E85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4831 19.9722L57.5397 14.1421C57.9534 14.0732 58.3669 14.004 58.7807 13.8662C61.5382 13.0389 63.7443 10.9362 63.7443 7.42026C63.7443 2.97377 60.1939 0.388672 54.989 0.388672H41.8218V23.6208H48.0608V15.4515V14.9002V10.3848V8.55815V5.04224H54.1618C56.2989 5.04224 57.3673 6.17968 57.3673 7.59285C57.3673 9.35063 56.2299 10.3848 54.0583 10.3848H51.3896V14.9914L56.5401 23.6209H59.9815L61.4831 19.9722Z",
    fill: "#587E85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.791 5.43935L97.3421 0.388916H89.6211L97.9969 11.9017L91.6534 20.669L92.8894 23.621H97.1008L100.684 18.6439L100.791 5.43935Z",
    fill: "#587E85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.615 11.9016L115.025 0.388916H107.408L103.902 5.43195L103.903 18.666L107.338 23.621H115.06L106.615 11.9016Z",
    fill: "#587E85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0236 7.75952L63.4189 23.6299H70.1404L71.6918 19.3209H74.1843L70.0236 7.75952Z",
    fill: "#587E85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6446 23.6299H89.4432L79.6539 0.190918H74.2046L82.6446 23.6299Z",
    fill: "#587E85"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000488281V23.5906H6.2062V11.452L11.819 15.9439V8.50126L0.891756 0.000488281H0Z",
    fill: "#587E85"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0931 0.000488281L15.2437 8.49192V15.9295L20.8127 11.4182V23.5906H27.0189V0.000488281H26.0931Z",
    fill: "#587E85"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6443 23.6314L74.2045 0.192627L73.1312 0.205492L71.8481 3.36358L79.4824 23.6314H82.6443Z",
    fill: "#B4C5C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLogo);
export default __webpack_public_path__ + "static/media/home-logo.f1504d488729635eeac956c35119ffb3.svg";
export { ForwardRef as ReactComponent };